/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2019 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * The Input Plugin Shutdown Event.
 * 
 * This internal event is dispatched by the Input Plugin when it shuts down, signalling to all of its systems to shut themselves down.
 *
 * @event Phaser.Input.Events#SHUTDOWN
 */
module.exports = 'shutdown';



//////////////////
// WEBPACK FOOTER
// ./node_modules/phaser/src/input/events/SHUTDOWN_EVENT.js
// module id = 1182
// module chunks = 0